"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var legacy_1 = require("satcheljs/lib/legacy");
var store_1 = require("../store/store");
exports.default = legacy_1.action('removeNotification')(function removeNotification(notification) {
    var index = store_1.default.notificationViewStates.indexOf(notification);
    if (index >= 0) {
        store_1.default.notificationViewStates.splice(index, 1);
    }
});
//# sourceMappingURL=removeNotification.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/controls/owa-header-toast-notification/lib/actions/removeNotification.js
// module id = 367
// module chunks = 3 14 105 106 107